import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import './AdminLayout.css';
import { auth } from '../firebase/firebase-config';

// İkonlar için basit SVG'ler kullandım (Harici kütüphane gerektirmez)
const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
);

const AdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation(); // Hangi sayfadayız anlamak için
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login'); // Çıkış yapınca login'e at
    } catch (error) {
      console.error("Çıkış hatası:", error);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Menü Linkleri (Daha sonra buraya yenilerini eklersin)
  const menuItems = [
    { path: '/admin/dashboard', label: 'Genel Bakış' },
    { path: '/admin/articles', label: 'Makaleler' },
    { path: '/admin/news', label: 'Haberler' },
    { path: '/admin/services', label: 'Hizmetler' },
    { path: '/admin/ekibimiz', label: 'Ekibimiz' },
    { path: '/admin/settings', label: 'Ayarlar' },
        { path: '/admin/faq', label: 'Sıkça Sorulan Sorular' },

  ];

  return (
    <div className="admin-container">
      {/* --- SIDEBAR --- */}
      <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">AG</div>
          <div className="sidebar-title">
            <h3>Arzu Gül</h3>
            <span>Yönetim Paneli</span>
          </div>
          {/* Mobilde kapatma butonu */}
          <button className="close-sidebar-btn" onClick={toggleSidebar}>
            <CloseIcon />
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link 
                  to={item.path} 
                  className={location.pathname === item.path ? 'active' : ''}
                  onClick={() => setIsSidebarOpen(false)} // Mobilde tıklayınca kapansın
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-btn">
            Güvenli Çıkış
          </button>
        </div>
      </aside>

      {/* Mobilde sidebar açılınca arka planı karartan overlay */}
      {isSidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

      {/* --- MAIN CONTENT --- */}
      <div className="main-content">
        {/* --- NAVBAR --- */}
        <header className="top-navbar">
          <div className="navbar-left">
            <button className="menu-toggle-btn" onClick={toggleSidebar}>
              <MenuIcon />
            </button>
            <h2 className="page-title">Yönetim Paneli</h2>
          </div>
          
          <div className="navbar-right">
            <div className="user-info">
              <span className="user-name">Admin</span>
              <div className="user-avatar">A</div>
            </div>
          </div>
        </header>

        {/* --- DİNAMİK İÇERİK ALANI --- */}
        <main className="page-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;